<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <b-button v-b-modal.modalDialog
          variant="primary">
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <div class="card mb-1">
      <div class="card-body p-1">
        <b-row>
          <!-- <b-col cols="12"
            md="3">
            <v-select v-model="channel_group_id"
              :options="dataChannelGroup"
              label="display_name"
              :reduce="(val) => val.Id"
              placeholder="--Danh mục kênh--" />
          </b-col> -->
          <!-- <b-col cols="12"
            md="3">
            <v-select v-model="type"
              :options="dataType"
              label="name"
              :reduce="(val) => val.id"
              placeholder="--Loại--" />
          </b-col> -->
          <b-col cols="12"
            md="6">
            <b-input-group class="mb-0">
              <b-form-input v-model="localSearchQuery"
                class="d-inline-block"
                placeholder="Tìm kiếm theo tên kênh"
                @keyup.enter="updateSearchQuery" />
              <b-input-group-append>
                <b-button variant="primary"
                  @click="updateSearchQuery">
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- List -->
    <b-overlay :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm">
      <b-card no-body
        class="mb-0">
        <b-table ref="refListTable"
          :items="dataItems"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching records found">
          <template #cell(name)="data">
            <span class="title"
              @click="edit(data.item)"><b>{{ data.item.name }}</b></span>
          </template>
          <template #cell(type)="data">
            <span v-if="data.item.type == 'video'">Video</span>
            <span v-else>Audio</span>
          </template>
          <template #cell(view)="data">
            <button v-if="data.item.type == 'video'"
              type="button"
              class="btn btn-sm btn-warning"
              @click="showView(data.item)">
              <feather-icon icon="TvIcon" /> Trực tuyến </button>
            <button v-else
              type="button"
              class="btn btn-sm btn-warning"
              @click="showView(data.item)">
              <feather-icon icon="RadioIcon" /> Phát thanh </button>
          </template>
          <template #cell(live)="data">
            <b-button v-if="data.item.live"
              variant="success"
              class="btn-icon rounded-circle btn-sm"
              @click="onLiveStream(data.item, 'pause')">
              <feather-icon icon="PauseCircleIcon" />
            </b-button>
            <b-button v-if="!data.item.live"
              variant="outline-primary"
              class="btn-icon rounded-circle btn-sm"
              @click="onLiveStream(data.item, 'start')">
              <feather-icon icon="PlayIcon"
                style="position: relative;left: 2px;" />
            </b-button>
          </template>
          <template #cell(status)="data">
            <span v-if="data.item.status"
              class="badge badge-light-success">Đang kích hoạt</span>
            <span v-else
              class="badge badge-light-danger">Đang dừng</span>
          </template>
          <template #cell(actions)="data">
            <b-button size="sm"
              class=""
              variant="outline-primary"
              @click="edit(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <b-button size="sm"
              class="ms-2"
              variant="outline-danger"
              @click="onDestroy(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of, }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon"
                    size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon"
                    size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal id="modalDialog"
      no-close-on-backdrop
      hide-footer
      size="lg"
      :title="dialog_title"
      @close="hidenModal">
      <channel-form :data-edit="dataEdit"
        :data-type="dataType"
        :data-channel-group="dataChannelGroup"
        :channel-category="channelCategory"
        @updateList="handleDialog" />
    </b-modal>
    <b-modal id="modalView"
      no-close-on-backdrop
      hide-footer
      size="lg"
      :title="modal_title"
      @close="hidenView">
      <channel-view :item-view="itemView" />
    </b-modal>
    <b-modal id="scheduleItem"
      no-close-on-backdrop
      hide-footer
      title="Tạo lịch ghi"
      @close="hidenModal">
      <schedule-item :data-edit="dataEdit"
        @updateLiveStream="handLivestream" />
    </b-modal>
  </div>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BFormCheckbox,
  BPagination,
  BInputGroupAppend,
  BInputGroup,
  BFormGroup,
  BLink,
} from 'bootstrap-vue';
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { showToast } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import vSelect from 'vue-select';
import ChannelForm from './ChannelForm.vue';
import ChannelView from './ChannelView.vue';
import ScheduleItem from './ScheduleItem.vue'

export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    ChannelForm,
    BFormGroup,
    BLink,
    vSelect,
    ChannelView,
    ScheduleItem,
  },
  data() {
    return {
      dialog_title: 'Thêm mới',
      modal_title: 'Xem truyền hình',
      dataEdit: {},
      itemView: {},
    };
  },
  setup() {
    const refListTable = ref(null);
    const dataChannelGroup = ref([]);
    const channelCategory = ref([])
    const dataType = ref([]);
    const channel_group_id = ref('');
    const tableColumns = [
      // { key: 'id', sortable: false, label: 'ID', thAttr: { width: '6%' } },
      { key: 'name', sortable: false, label: 'Tên kênh' },
      {
        key: 'type', sortable: false, label: 'Loại', thAttr: { width: '10%' },
      },
      {
        key: 'view', sortable: false, label: 'Xem', thAttr: { width: '15%' },
      },
      {
        key: 'live', sortable: false, label: 'Live', thAttr: { width: '8%' },
      },
      {
        key: 'status',
        sortable: false,
        label: 'Trạng thái',
        thAttr: { width: '9%' },
      },
      {
        key: 'actions',
        label: 'Hành động',
        class: 'action',
        thAttr: { width: '6%' },
      },
    ];
    const perPage = ref(30);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 30, 50, 100];
    const searchQuery = ref('');
    const localSearchQuery = ref('');
    const loading = ref(true);
    const dataItems = ref([]);
    const type = ref('');

    const fetchAll = () => {
      store
        .dispatch('channel/fetchall', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          card_type: 'channel',
          type: type.value,
          channel_group_id: channel_group_id.value,
        })
        .then((response) => {
          loading.value = false;
          const result = response.data;

          if (result.code === 200) {
            dataItems.value = result.data.data;
            total.value = result.data.total;
            channelCategory.value = result.data.channelCategory;
            if (Object.keys(result.data.channelGroup).length > 0) {
              dataChannelGroup.value = result.data.channelGroup;
            }
            if (Object.keys(result.data.dataType).length > 0) {
              dataType.value = result.data.dataType;
            }
          }
        });
    };
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });
    fetchAll();
    watch([currentPage, perPage, searchQuery, type, channel_group_id], () => {
      refetchData();
    });

    const refetchData = () => {
      fetchAll();
    };

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value;
    };
    return {
      loading,
      dataItems,
      perPage,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      updateSearchQuery,
      localSearchQuery,
      dataChannelGroup,
      dataType,
      channel_group_id,
      type,
      channelCategory,
    };
  },
  methods: {
    hidenModal() {
      this.$bvModal.hide('modalDialog');
      this.$bvModal.hide('scheduleItem');
      this.dataEdit = {};
    },
    hidenView() {
      this.$bvModal.hide('modalView');
      this.itemView = {};
    },
    handleDialog() {
      this.refetchData();
      this.dataEdit = {};
      this.$bvModal.hide('modalDialog');
    },
    edit(item) {
      this.dataEdit = item;
      this.dialog_title = 'Cập nhật';
      this.$bvModal.show('modalDialog');
    },
    showView(item) {
      if (item.type == 'audio') {
        this.modal_title = 'Nghe phát thanh';
      }
      this.itemView = item;
      this.$bvModal.show('modalView');
    },
    onDestroy(item) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa kênh này không?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const { id } = item;
          const card_type = 'channel';
          store
            .dispatch('channel/destroy', { id, card_type })
            .then((response) => {
              const result = response.data;
              if (result.code === 200) {
                showToast(result.message, { variant: 'success' });
                this.refetchData();
              } else {
                showToast(result.message);
              }
            });
        }
      });
    },

    handLivestream() {
      this.$bvModal.hide('scheduleItem');
      this.dataEdit.live = true;
    },
    onLiveStream(item, type) {
      const params = {
        id: item.id,
        type,
      }

      const flag = false;
      if (type == 'pause') {
        this.$swal({
          title: '',
          html: 'Bạn có chắc chắn muốn tắt chương trình đang ghi lại này không',
          icon: '',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy',
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            store.dispatch('channel/livestream', params).then(response => {
              const result = response.data;
              if (result.code == 200) {
                item.live = false;
                showToast(result.message, { variant: 'success' });
              } else {
                showToast(result.message);
              }
            })
          }
        });
      } else {
        store.dispatch('channel/livestream', params).then(response => {
          const result = response.data;
          if (result.code == 200) {
            if (type == 'start') {
              if (result.data.length > 0) {
                this.$swal({
                  title: '',
                  html: result.message,
                  icon: '',
                  showCancelButton: true,
                  confirmButtonText: 'Đồng ý',
                  cancelButtonText: 'Hủy',
                  customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger ml-1',
                  },
                  buttonsStyling: false,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.dataEdit = item;
                    this.$bvModal.show('scheduleItem')
                  }
                });
              } else {
                this.dataEdit = item;
                this.$bvModal.show('scheduleItem')
              }
            } else {
              item.live = false;
              showToast(result.message, { variant: 'success' });
            }
          } else {
            showToast(result.message);
          }
        })
      }
    },
    updateStatus(item) {
      const { id } = item;
      const card_type = 'channel';
      store.dispatch('channel/status', { id, card_type }).then((response) => {
        const result = response.data;
        if (result.code === 200) {
          showToast(result.message, { variant: 'success' });
          this.refetchData();
        } else {
          showToast(result.message, { variant: msg_class });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
